export default __webpack_public_path__ + "static/media/xk.859f3ba6.svg";